<lxm-dialog [dialogRef]="dialogRef" [formGroup]="form">
    <span header-title>
      {{ 'cards.offer.campaign_info.title' | translate }}
    </span>

    <div body>

        <display-product class="dialog-display-product-sticky" [data]="product"> </display-product>

        <scope translationsPath="cards.offer.campaign_info">

          <form-field dialog label="product_has_display" for="campaignType" [readonly]="readonly">
            <slide-toggle
                for="display"
                [readonly]="readonly || !product.productHasDisplay"
              ></slide-toggle>
          </form-field>
    

          <form-field dialog label="netting">
            <slide-toggle toggle for="netting" [readonly]="isRetailer || readonly"></slide-toggle>
            <validation-errors for="netting"></validation-errors>
          </form-field>

          <form-field dialog label="addressed">
            <slide-toggle toggle for="addressed" [readonly]="isRetailer || readonly"></slide-toggle>
            <validation-errors for="addressed"></validation-errors>
          </form-field>

          <form-field dialog label="with_ad">
            <slide-toggle toggle for="withAd" [readonly]="readonly"></slide-toggle>
            <validation-errors for="withAd"></validation-errors>
          </form-field>

          <form-field dialog label="marketing_fee" for="marketingFee" [readonly]="readonly">
            <lxm-input for="marketingFee" class="w-full md:w-[200px]" [readonly]="readonly"></lxm-input>
            <validation-errors for="campaignInfo.marketingFee" aliasTo="marketingFee"></validation-errors>
          </form-field>

          <form-field dialog label="invoice_recipient">
            <lxm-select select
                        labelField="value"
                        [searchable]="true"
                        for="invoiceRecipient"
                        url="api/clvac/manufacturers/"
                        class="w-full md:w-[300px]"
                        [readonly]="isRetailer || readonly">
            </lxm-select>
            <validation-errors for="campaignInfo.invoiceRecipient" aliasTo="invoiceRecipient"></validation-errors>
          </form-field>

          <div class="separator"></div>

          <form-field dialog label="store_count" for="storeCount" [readonly]="readonly">
            <lxm-input for="storeCount" class="w-full md:w-[200px]" [readonly]="readonly"></lxm-input>
            <validation-errors for="campaignInfo.storeCount" aliasTo="storeCount"></validation-errors>
          </form-field>

          <form-field dialog label="display_size" for="displaySize" [readonly]="readonly">
            <lxm-input for="displaySize" class="w-full md:w-[200px]" [readonly]="readonly"></lxm-input>
            <validation-errors for="campaignInfo.displaySize" aliasTo="displaySize"></validation-errors>
          </form-field>

          <form-field dialog label="returnable_items">
            <lxm-select select [options]="returnableItemsOptions" for="returnableItems" value="id" [readonly]="isRetailer || readonly" class="w-full md:w-[200px]"></lxm-select>
            <validation-errors for="campaignInfo.returnableItems" aliasTo="returnableItems"></validation-errors>
          </form-field>

          <form-field dialog label="limit" for="limit" [readonly]="readonly">
            <lxm-input for="limit" class="w-full md:w-[200px]" [readonly]="readonly"></lxm-input>
            <validation-errors for="limit"></validation-errors>
          </form-field>

          <form-field dialog label="comments" for="comments" [readonly]="isRetailer || readonly">
            <lxm-textarea for="comments" class="w-full" [readonly]="isRetailer || readonly"></lxm-textarea>
            <validation-errors for="campaignInfo.comments" aliasTo="comments"></validation-errors>
          </form-field>
 
          <form-field dialog label="campaign_nr" for="campaignNr" [readonly]="readonly">
            <lxm-input for="campaignNr" class="w-full md:w-[200px]" [readonly]="readonly"></lxm-input>
            <validation-errors for="campaignInfo.campaignNr" aliasTo="campaignNr"></validation-errors>
          </form-field>

        </scope>
    </div>

    <div footer>
      <lxm-button type="primary" label="action.save" [loading]="isSaveLoading" (click)="save()" buttonType="submit" *ngIf="!readonly"></lxm-button>
      <lxm-button type="tertiary" [label]="readonly ? 'action.close' : 'action.cancel'" (click)="closeDialog()"></lxm-button>
    </div>
</lxm-dialog>
